<!-- Page 1 -->
<div class="pdf-page app-priv-0100-6-22">
  <p class="font-small" style="text-align: center">
    <b><span style="text-decoration: underline">Privacy Policy</span></b>
  </p>
  <p>
    You have a relationship with one or more of the following Fortegra Financial
    Corporation subsidiaries:
    <i
      >LOTSolutions, Bankers Life Insurance Company of Louisiana, Blue Ridge
      Indemnity Insurance Company, Insurance Company of the South, Life of the
      South Insurance Company, Lyndon Southern Insurance Company, Response
      Indemnity Company of California, Southern Financial Life Insurance Company
      and Fortegra Specialty Insurance Company (hereby referred to collectively
      as “Fortegra”).</i
    >
    The trust of our customers is our most valuable asset. In the course of
    providing products and services to you, we will obtain information about
    you. Your trust in providing this information is safeguarded in accordance
    with this Privacy Policy.
  </p>
  <p>
    Our Privacy Policy generally describes how Fortegra obtains and discloses
    nonpublic information, provides examples of nonpublic information we may
    collect and lists the companies with which we may share this information.
    Nonpublic information may be collected from persons other than you and it
    may be disclosed to third parties without further authorization from you.
    The below examples are for illustrative purposes only and are not intended
    to be considered a complete description of all information we collect,
    maintain, or use in our sharing practices. You may have additional privacy
    protection under some State laws. We will comply with the applicable State
    and Federal laws regarding nonpublic information about you.
  </p>
  <p>
    <b><i>Information we may collect.</i></b>
  </p>
  <div style="margin-left: 20px">
    <p>
      <span style="text-decoration: underline"
        ><b><i>Customer Information</i></b></span
      >. Customer information includes identifying information such as your
      name, address, telephone number, employer, social security number, income,
      age, and demographic data. It also includes information related to your
      transactions with Fortegra (i.e., claims history, premiums, and insurance
      coverage.)
    </p>
    <p>
      <span style="text-decoration: underline"
        ><b><i>Financial Information</i></b></span
      >. Financial information is information covered by the Fair Credit
      Reporting Act and includes details related to your credit history, credit
      card usage, income assets, and loan records. It also includes information
      from consumer reporting agencies, public records, and data collection
      agencies.
    </p>
    <p>
      <span style="text-decoration: underline"
        ><b><i>Health Information</i></b></span
      >. Health information includes medical history provided by doctors, health
      care providers, insurance companies, and you. Health information will be
      collected, as authorized by you or otherwise permitted by law, as we deem
      appropriate to determine eligibility for coverage, to process claims, and
      to prevent fraud.
    </p>
  </div>
  <p>
    <b><i>What we do with the information we obtain</i></b>
  </p>
  <p>
    The nonpublic information we may collect as described above may be
    disclosed, when permitted by law, in order to offer you products and
    services. Examples of disclosures permitted by law include those to
    organizations that provide claims administration, underwriting, audits,
    investigation and/or policyholder services. We may use affiliated and
    nonaffiliated parties to perform these services. If you wish for your
    personal information to not be shared with third parties, you must send
    written notice using <a>www.fortegra.com/datasubject-access.</a> Services
    also include protecting against fraud and companies who maintain software
    for us. We may also disclose information in response to requests from law
    enforcement authorities or State insurance authorities.
  </p>
  <p>
    <b><i>Independent Sales Agents and Agents in General.</i></b>
  </p>
  <p>
    Sales agents who represent us are independent, and your independent sales
    agent may gather and retain customer information, financial information,
    and/or health information about you. The use and protection of this
    information by your independent sales agent is your independent sales
    agent's responsibility,
    <i
      >not the responsibility of Fortegra Financial Corporation or its
      affiliated companies.</i
    >
    If you have questions about how your independent sales agent may use or
    disclose this information, please contact your independent sales agent.
  </p>
</div>

<!-- Page 2 -->
<div class="pdf-page app-priv-0100-6-22">
  <p>
    <b><i>Information regarding Former Customers.</i></b>
  </p>
  <p>
    We do not disclose nonpublic personal information about former customers
    except in accordance with this Privacy Policy.
  </p>
  <p>
    You have a right of access and correction with respect to all personal
    information collected. All request for access or correction of personal
    information shall be submitted in writing using
    <a>www.fortegra.com/datasubject-access.</a> Fortegra Financial Corporation
    shall respond to requests within thirty (30) business days from the date of
    receipt. Such responses shall make the requested change to the personal
    information or provide notice and explanation as to why they personal
    information will not be changed.
  </p>
  <p>
    <b><i>Changes to our Privacy Policy</i></b>
  </p>
  <p>
    We reserve the right to modify, change or supplement this Privacy Policy at
    any time. If we make material changes to this policy, we will provide our
    customers with a revised notice that describes our new practices.
  </p>
  <p>
    For additional details related to our Privacy Policy and your rights related
    to collection and disclosure of your nonpublic personal information, please
    visit: <a>www.fortegra.com/privacy-policy.</a>
  </p>
</div>
